<template>
  <transition name="fade">
    <section :class="['section', 'section--resource']">
      <div class="wrapper">
        <div class="content">
          <div class="resource-single-item">
            <span class="resource-single-title">{{resourceDetails.title}}</span>
            <span class="resource-single-type" v-html="resourceDetails.resource_type"></span>
            <div class="resource-single-visual">
              <img :src='resourceDetails.image && resourceDetails.image.path' />
            </div>
            <div class="resource-item-info">
              <div class="resource-info-col">
                <button class="view-btn view-btn--dark"
                        @click="downloadFile(resourceDetails.files.path, resourceDetails.files.file_name)">
                  DOWNLOAD
                </button>
              </div>
              <div class="resource-info-col">
                <h3 class="resource-info-title">Format</h3>
                <div v-html="resourceDetails.format"></div>
              </div>
              <div class="resource-info-col">
                <h3 class="resource-info-title">Size</h3>
                <div v-html="resourceDetails.size"></div>
              </div>
              <div class="resource-info-col">
                <h3 class="resource-info-title">Designers</h3>
                <div v-html="resourceDetails.designers"></div>
              </div>
            </div>
            <div class="resource-text-content" v-if="resourceDetails.content" v-html="resourceDetails.content"></div>
          </div>
        </div>
        <Footer />
      </div>
    </section>
  </transition>
</template>

<script>
import { mapActions } from 'vuex';

import SquareDummy from '@/components/SquareDummy';
import Footer from '@/components/UI/Footer';
import { transformTablesIntoLists, downloadFile } from '@/utils/helpers';

export default {
  props: ['sectionData'],
  components: {
    SquareDummy,
    Footer,
  },
  data() {
    return {
      resourceDetails: {
        preview_title: '',
        preview_content: '',
        preview_image: {
          path: '',
        },
        title: '',
        resource_type: '',
        image: {
          path: '',
        },
        files: {
          path: '',
          file_name: '',
        },
        format: '',
        size: '',
        designers: '',
        content: '',
      },
    };
  },
  async created() {
    const { id } = this.$router.currentRoute.params;
    const resourceDetails = await this.fetchResourceDetails(id);
    const { content, ...restDetails } = resourceDetails;
    this.resourceDetails = { ...restDetails, content: this.transformContent(content) };
  },
  methods: {
    ...mapActions({ fetchResourceDetails: 'resource/resourceDetails:fetch' }),
    transformContent(originalContent) {
      return transformTablesIntoLists(originalContent);
    },
    downloadFile(filePath, fileName) {
      return downloadFile(filePath, fileName);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ResourcesDetails.vue